import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  Typography,
  Button,
  Grid,
  Divider,
  Chip,
  Container,
  Stack,
  Dialog,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import PublicIcon from "@mui/icons-material/Public";
import LockIcon from "@mui/icons-material/Lock";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getBankAccounts } from "../../services/BlockOpenAccountPageService";
import { TextStyled } from "../../styles/CustomTypography";
import CloseIcon from "@mui/icons-material/Close";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import Rating from "@mui/material/Rating";


const BlockAccountCard = () => {
  const { country_id } = useSelector((state) => state.auth || {});
  const [banks, setBanks] = useState([]);
  const [total, setTotal] = useState(0);

  const [openImage, setOpenImage] = useState(false);
  const [popupImage, setPopupImage] = useState("");

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const navigate = useNavigate();

  const fadeUp = {
    hidden: { opacity: 0, y: 60 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
      },
    },
  };

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const getResponsiveHtml = (html) => {
    if (!html) return "";
    if (!isMobile) return html.replace(/<br\s*\/?>/gi, "").replace(/&nbsp;/gi, " ").replace(/\u00A0/gi, " ").replace(/\[empty_line\]/gi, "<br />");

    return html
      .replace(/<br\s*\/?>/gi, "")
      .replace(/font-size:\s*\d+px/gi, "font-size: 18px")
      .replace(/font-weight:\s*900/gi, "font-weight: 700")
      .replace(/&nbsp;/gi, " ")
      .replace(/\u00A0/gi, " ")
      .replace(/\[empty_line\]/gi, "<br />");
  };


  useEffect(() => {
    fetchBanks();
  }, [country_id]);

  const fetchBanks = async () => {
    const res = await getBankAccounts(1, 3, country_id);
    setBanks(res.data.data || []);
    setTotal(res.data.pagination?.total || 0);
  };

  const getGridSize = () => {
    if (banks.length === 1) return 12; // Full width
    if (banks.length === 2) return 6;  // 2 per row
    return 4; // 3 per row
  };

  const gridSize = getGridSize();

  return (
    <Container
      ref={ref}
      component={motion.div}
      variants={fadeUp}
      initial="hidden"
      animate={inView ? "visible" : "hidden"}
      sx={{
        py: { xs: 2, sm: 2, md: 3 },
        px: { xs: 3, sm: 4, md: 6 },
        paddingLeft: { xs: "24px !important", md: "48px !important" },
        paddingRight: { xs: "24px !important", md: "48px !important" }
      }}>
      <Grid container spacing={3} alignItems="stretch">
        {banks.map((bank, index) => (
          <Grid
            component={motion.div}
            variants={fadeUp}
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
            transition={{ delay: index * 0.2 }}
            key={bank.id}
            size={{ xs: 12, sm: 6, md: gridSize }}
            display="flex"
          >
            <>
              <Card
                component={motion.div}
                whileHover={{ y: -6 }}
                sx={{
                  backgroundColor: "#FFF4E6",
                  borderRadius: "10px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  pt: "18px",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {/* Header */}
                <Grid class="header-img" container alignItems="center" justifyContent="center" sx={{ p: "0px 18px" }}>
                  <Box
                    component="img"
                    src={bank.bank_logo_url}
                    alt={bank.bank_name}
                    sx={{ objectFit: "cover", borderRadius: 0.5 }}
                  />
                </Grid>

                {/* Tag */}
                {/* <Button
                  label={bank.bank_level || "Open Your Block Account"}
                  sx={{
                    mt: 2,
                    mb: 1.5,
                    p: "15px 25px",
                    borderRadius: "0px 5px 5px 0px",
                    fontWeight: 800,
                    backgroundColor: "#FFE500",
                    color: "#000",
                  }}
                /> */}
                <Button
                  variant="contained"
                  sx={{
                    mt: 2,
                    backgroundColor: "#FFE500",
                    color: "#000",
                    textTransform: "none",
                    borderRadius: "5px",
                  }}
                  onClick={() => window.open(bank.bank_open_account_linkurl, "_blank")}
                >
                  Open Your Block Account
                </Button>

                {/* Bullets */}
                {/* <Stack spacing={1.2} sx={{ mb: 2, p: "0px 18px" }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <PublicIcon fontSize="small" />
                    <TextStyled variant="body2">
                      {bank.bank_availability || "Available Worldwide"}
                    </TextStyled>
                  </Box>

                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <LockIcon fontSize="small" />
                    <TextStyled variant="body2">
                      {bank.bank_level || "Highest Security Level"}
                    </TextStyled>
                  </Box>
                </Stack> */}

                {/* <Divider sx={{ mb: 2 }} /> */}

                {/* Price */}
                <Grid container spacing={2} sx={{ mb: 2, p: "0px 18px" }}>
                  {/* <Grid size={{ xs: 12 }}>
                    <Typography sx={{ fontSize: 22, fontWeight: 800 }}>
                      € {bank.bank_fees}
                    </Typography>

                    <Typography variant="body2" color="text.secondary">
                      {bank.bank_fees_desc}
                    </Typography>
                  </Grid> */}
                  {/* 
                  <Grid size={{ xs: 12 }} sx={{ display: "flex", gap: 1.5 }}>
                    <Button
                      variant="contained"
                      sx={{
                        backgroundColor: "#000",
                        color: "#FF9500",
                        textTransform: "none",
                      }}
                      onClick={() => window.open(bank.bank_open_account_linkurl, "_blank")}
                    >
                      Open Your Block Account
                    </Button>

                    <Button
                      variant="contained"
                      sx={{
                        backgroundColor: "#000",
                        color: "#FF9500",
                        textTransform: "none",
                      }}
                      onClick={() => window.open(bank.bank_info_linkurl, "_blank")}
                    >
                      More Info
                    </Button>
                  </Grid> */}
                </Grid>

                {/* Rating */}
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.6, mb: 2, p: "0px 18px" }}>
                  <Typography sx={{ fontWeight: 700, color: "#000", }}>
                    {bank.bank_rating}
                  </Typography>

                  <Rating
                    value={bank?.bank_rating || 0}
                    precision={0.1} // allows 4.2, 3.7, etc.
                    readOnly
                    sx={{
                      color: "#FFD600",
                      fontSize: 20,
                    }}
                  />

                  {bank?.bank_rating_link && (
                    <Typography
                      sx={{ fontSize: '14px', cursor: "pointer", color: "#000", }}
                      onClick={() => window.open(bank.bank_rating_link, "_blank")}
                    >
                      (Review)
                    </Typography>
                  )}
                </Box>

                {/* Description */}
                <Box
                  sx={{
                    flexGrow: 1,
                    border: "1px solid #FF9500",
                    borderRadius: "10px",
                    p: "20px",
                    backgroundColor: "#FFF4E6",
                  }}
                >
                  {/* Highlight Text */}
                  <Typography
                    sx={{
                      color: "#000",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: getResponsiveHtml(bank.bank_highlight) || "<p>No description available.</p>",
                    }}
                  />
                </Box>
              </Card>
            </>
          </Grid>
        ))}
      </Grid>
      <Dialog
        open={openImage}
        onClose={() => setOpenImage(false)}
        fullScreen
        sx={{ backgroundColor: "rgba(0,0,0,0.9)" }}
      >
        <IconButton
          onClick={() => setOpenImage(false)}
          sx={{
            position: "absolute",
            top: 20,
            right: 20,
            color: "#000",
            zIndex: 10,
          }}
        >
          <CloseIcon fontSize="large" />
        </IconButton>

        <Box
          sx={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            p: 2,
          }}
        >
          <Box
            component="img"
            src={popupImage}
            alt="Preview"
            sx={{
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "contain",
              borderRadius: 2,
            }}
          />
        </Box>
      </Dialog>
    </Container >
  );
};

export default BlockAccountCard;
